import React from "react";
import "./SampleAadharPopup.scss";
import GuideModal from "../../UI/GuideModal/GuideModal";
import { IViewSampleAadharPopup } from "./SampleAadharPopup";

// Fallback for "View Sample" when no document is selected yet, or the selected
// document has no dedicated sample, so the link always opens something.
const SampleGenericPopup = (props: IViewSampleAadharPopup) => {
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  return (
    <GuideModal
      open={!!props.showPopup}
      onClose={closePopup}
      title="Uploading Document Formats"
      titleId="sample-generic-popup-title"
    >
      <div className="Aadhar-format-1">
        <span>
          <span className="Aadhar-format-1-title">
            Select a document to see its sample
          </span>
          <p className="Aadhar-format-read-more">
            Choose a document from the list above. Samples are available for
            Aadhaar, Passport, Voter ID and Driving Licence.
          </p>
        </span>
      </div>
      <div className="Aadhar-format-2">
        <span>
          <span className="Aadhar-format-1-title">While uploading</span>
          <ul className="Aadhar-format-read-more">
            <li>Upload a clear, colour scan or photo with all four corners visible.</li>
            <li>Attach both front and back, either as two images or in a single PDF.</li>
            <li>Make sure your name, address and document number are readable.</li>
            <li>Accepted formats: PDF, JPG, JPEG (Max size: 5MB).</li>
          </ul>
        </span>
      </div>
    </GuideModal>
  );
};
export default SampleGenericPopup;
